import Helpers from "@helpers"
import React, { useRef, RefObject } from "react"
import overlayHelper from "../overlay/overlay"
import { AddressMapModalHelper, State } from "./model"
import LeafletMap from "../map/leaflet"

const AddressMapModalHelper: AddressMapModalHelper = {}

class AddressMapModal extends React.Component<{}, State> {
  private leafletMapRef: RefObject<LeafletMap> | null
  private onFinished
  private reloadAddressList
  private timeout

  constructor(props) {
    super(props)
    this.state = this.getInitialState()
    this.leafletMapRef = React.createRef<LeafletMap>()
    this.timeout = null
  }

  public componentWillUnmount() {
    clearTimeout(this.timeout)
  }

  public componentDidMount() {

    AddressMapModalHelper.openAddressModal = this.openModal
  }

  public componentDidUpdate() {
      //Helpers.LoadingHelper.showLoading()
  }

  handleSearch = () => {

    fetch(
      `/wservice/useraddressws.ashx?action=search-address&search=${this.state.searchQuery}`,
      {
        method: "GET",
      }
    )
      .then((response) => response.json())
        .then((data) => {
            if (data) {
                this.setState({ searchItemList: data })
                this.setState({ activeSearchItems: true })
            }
      })
      .catch((error) => {
        this.setState({ activeSearchItems: false })
      })
      .finally(() => {
        Helpers.LoadingHelper.hideLoading()
      })
  }

  handleInputChange = (event) => {
    this.setState({ searchQuery: event.target.value })

    if (event.target.value !== "") {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(this.handleSearch, 500)
    } else {
      this.setState({ activeSearchItems: false })
    }
  }

  private getInitialState = (): State => ({
    visible: false,
    lat: 35.699736,
    lng: 51.338058,
    btnSaveClassName:
      "btn btn-gray btn-disabled address-modal-save profile-button-container",
    address: "",
    addressId: null,
    searchQuery: "",
    searchItemList: [],
    activeSearchItems: false,
  })

  private updateBtnSaveClassName = () => {
    this.setState({
      btnSaveClassName:
        "btn btn-red address-modal-save profile-button-container",
    })
  }

  private setMapToPostion(lat, lng) {
    this.leafletMapRef.current.setTestMapTo(lat, lng)
    this.setState({ activeSearchItems: false })
  }

  handleSave = () => {
    this.getMapLatLng(() => {
      Helpers.ApiHelper.getAddressLatLng(this.state.lat, this.state.lng).done(
          (res) => {
          this.updateAddress(res.address)
          this.setState({ visible: false }, () =>
            this.onFinished(
              this.state.addressId,
              res.address,
              this.state.lat,
              this.state.lng,
              this.reloadAddressList
            )
          )
        }
      )
    })
  }

  updateAddress = (address) => {
    this.setState({ address })
  }
  handleMapMoveStart = (center: L.LatLng) => {
    this.updateBtnSaveClassName()
  }

  handleMapMove = (center: L.LatLng) => {}

  getMapLatLng = (done) => {
    if (this.leafletMapRef.current) {
      const mapLatLng = this.leafletMapRef.current.getMapLatLng()
      this.setState({ lat: mapLatLng.lat, lng: mapLatLng.lng }, () => {
        done()
      })
    }
  }

  private openModal = async (addressId, onFinished) => {
    this.onFinished = onFinished
    overlayHelper.onClick = this.closeModal
    this.setState({
      visible: true,
      addressId: addressId,
    })
  
      Helpers.LoadingHelper.hideLoading()


      setTimeout(() => {
      if (addressId) {
        var forceExUser = 0
        var uid = 0
        var hps = ""

        if ($("#hdfForceExUser").length > 0) {
          forceExUser = Helpers.Utils.zeroIfEmpty(
            $("#hdfForceExUser").val().toString()
          )
        }
        if ($("#hdfUId").length > 0) {
          uid = Helpers.Utils.zeroIfEmpty($("#hdfUId").val().toString())
        }
        if ($("#hdfHps").length > 0) {
          hps = $("#hdfHps").val().toString()
        }

        const getAddressPromise = Helpers.ApiHelper.getAddress(
          addressId,
          forceExUser,
          uid,
          hps
        ).then((response) => {
          if (response.latitude && response.longitude) {
            this.setState({
              lat: response.latitude,
              lng: response.longitude,
              address: response.address,
            })
          }
        })
      }
      }, 100)
    overlayHelper.showOverlay()
  }

  private clearModal = () => {
    this.setState(this.getInitialState())
  }

  private getModalDisplayStyle = () => (this.state.visible ? "block" : "none")

  private getErrorDisplayStyle = (errorMessage) =>
    errorMessage && errorMessage.length > 0 ? "block" : "none"

  private closeModal = () => {
    this.setState({
      visible: false,
    })
    overlayHelper.hideOverlay()
    this.clearModal()
  }

  public render() {
    const defaultLocation = { lat: this.state.lat, lng: this.state.lng }

    return (
      <div
        className="modal address-modal"
        style={{ display: this.getModalDisplayStyle() }}
      >
        <div className="fa fa-remove close-windows" onClick={this.closeModal} />
        <div className="row rounded address-form text-fa-h4 rtl">
          <div className="row custom-gutter modal-form-row">
            <div className="col-lg-12 ">
              <div className="map-search-box px-4">
                <input
                  type="text"
                  placeholder="جستجوی آدرس"
                  className="form-control mb-1 "
                  value={this.state.searchQuery.toString()}
                  onChange={this.handleInputChange}
                />

                {this.state.activeSearchItems ? (
                  <div className="suggestion-address p-2 ">
                    <ul className="p-2">
                      {this.state.searchItemList.map((item, index) => (
                        <li
                          key={index}
                          onClick={() =>
                            this.setMapToPostion(
                                item.Latitude,
                                item.Longitude
                            )
                          }
                        >
                              {item.Title}{" "}
                          <span className="text-secondary mr-1">
                                  ({item.Region})
                          </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>

              <LeafletMap
               onMapMoveStart={this.handleMapMoveStart}
               onMapMove={this.handleMapMove}
               ref={this.leafletMapRef}
               defaultLocation={defaultLocation}
              />

            </div>
          </div>
          <button
            className={this.state.btnSaveClassName}
            onClick={this.handleSave}
            type="button"
          >
            تائید موقعیت مکانی
          </button>
        </div>
      </div>
    )
  }
}

Helpers.ReactHelper.createReactElement("AddressMapModal", AddressMapModal)

export default AddressMapModalHelper
